fx.ns("desktop.common.screens", class BaseSplash extends fx.Component{
    
	constructor()
	{
		super();
		this.destroyOnSwitch = true;
	}

    get title()
    {
        return this._title;
    }

    set title(val)
    {
        this._title = val;
		if (this.initialized)
			this._titleComponent.text = val;
    }

    get subtitle()
    {
        return this._subtitle;
    }

    set subtitle(val)
    {
        this._subtitle = val;

		if (this.initialized)
			this._textComponent.text = val;
    }


	create()
	{
		let box = new fx.components.Box();

		
        box.addChild(new shared.component.Person(fx.get("assets").splashPhoto), {width:260, height : 260, top : 0, left : "center"});


		this._titleComponent = new fx.components.Text({text : fx.text(this.title), className : "title"});
		this._textComponent = new fx.components.Text({text : fx.text(this.subtitle), className : "text"});

		box.addChild(this._titleComponent, {width:"100%", height : 40, top : 280, left : "center"});
		box.addChild(this._textComponent, {width:"100%", height : 30, top : 330, left : "center"});

		this.addChild(box, { width : 400, height : 360, top : "center", left : "center"});
	}

});

	